<div
  #header
  class="nav-menu-header"
  nz-dropdown
  [nzPlacement]="'topRight'"
  [nzDropdownMenu]="appsMenu"
  nzTrigger="click"
  [ngClass]="{
    prod: env() === 'prod',
    pre: env() === 'pre',
    dev: env() === 'dev',
    open: !isOpen(),
    close: isOpen(),
  }"
>
  <p class="nav-menu-header__button">SABT</p>
  @if (!isOpen()) {
    <p>Volta SABT</p>
  }
</div>

<nz-dropdown-menu #appsMenu="nzDropdownMenu">
  @if (top() && left()) {
    <ul
      class="nav-menu-header__tools"
      [ngStyle]="{
        top: top() + 'px',
        left: left() + 'px',
      }"
    >
      <div class="nav-menu-header__tools__header">
        <ui-icon
          icon="icons:volta"
          class="text-[28px] px-0"
        />
        <p>Herramientas Volta</p>
      </div>
      @for (app of apps(); track $index) {
        <li class="nav-menu-header__tools__item" (click)="open(app)">
          {{ app.name }}
        </li>
      }
    </ul>
  }
</nz-dropdown-menu>
